<div class="container">
  <div class="row">
    <div class="col-12 text-center">
      @for (navItem of navItems; track navItem.name) {
        <span class="navItem">
          <a href="#" [routerLink]="navItem.url">
            <img [src]="getNavImage(navItem)" (mouseover)="navItem.isHover = true" (mouseout)="navItem.isHover = false">
          </a>
        </span>
      }
    </div>
  </div>
</div>
